import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import CalendarIcon from "@mui/icons-material/Event";
import { TextField, TextFieldProps } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import React from "react";

export interface DateTimePickerProps {
    value: Date | null;
    onChange(date: Date | null, value?: string | null): any;
    label: React.ReactNode;
    format?: string;
    margin?: 'dense' | 'none';
    required?: boolean | undefined;
    disabled?: boolean | undefined;
    fullWidth?: boolean | undefined;
    style?: React.CSSProperties;
}

export default function (props: DateTimePickerProps) {
    const { value, onChange, label, format, margin, required, fullWidth, disabled, style } = props;

    return (
        <DateTimePicker<Date, Date>
            label={label}
            inputFormat={format || 'dd/MM/yyyy HH:mm'}
            value={value}
            onChange={onChange}
            //cancelLabel={<Trans translateKey='cancel' namespace='form' capitalize />}
            //leftArrowIcon={<ArrowLeftIcon />}
            //rightArrowIcon={<ArrowRightIcon />}
            //inputVariant="outlined"
            //margin="dense"
            //todayLabel={<Trans translateKey='today' />}
            //showTodayButton
            //keyboardIcon={<CalendarIcon fontSize='small' />}
            //KeyboardButtonProps={{ style: { padding: 0 } }}
            InputAdornmentProps={{ style: { margin: 0 } }}
            //fullWidth={fullWidth}
            //invalidDateMessage={<Trans translateKey='elementInvalid' valuesToReplace={{ element: t('date') }} capitalize />}
            //required={required}                        
            ampm={false}
            disabled={disabled}
            renderInput={(inputProps) => (
                <TextField
                    {...inputProps}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    disabled={disabled}
                    required={required}
                    fullWidth={fullWidth}
                    style={style}
                />
            )}
        />
    )
}
